// extracted by mini-css-extract-plugin
export default {"policies-wrap":"policies-wrap-x4MjI","panel":"panel-d3PO_"};